import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconOnHold: React.FC<Props> = ({
  width = 24,
  height = 24,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.791 15.084C13.986 15.279 13.986 15.596 13.791 15.791C13.693 15.889 13.565 15.937 13.437 15.937C13.309 15.937 13.181 15.888 13.083 15.791L12.145 14.854C12.051 14.76 11.999 14.633 11.999 14.5V13.188C11.999 12.912 12.223 12.688 12.499 12.688C12.775 12.688 12.999 12.912 12.999 13.188V14.293L13.791 15.084ZM17 8.25H19.25L14.75 3.75V6C14.75 7.58 15.42 8.25 17 8.25ZM20 9.75V18C20 20 19 21 17 21H8C6 21 5 20 5 18V6C5 4 6 3 8 3H13.25V6C13.25 8.42 14.58 9.75 17 9.75H20ZM16 14.5C16 12.567 14.433 11 12.5 11C10.567 11 9 12.567 9 14.5C9 16.433 10.567 18 12.5 18C14.433 18 16 16.433 16 14.5Z"
      fill={color}
    />
  </svg>
);

export default IconOnHold;
